import { push } from 'react-router-redux';
import { all, put, takeEvery } from 'redux-saga/effects';
import { routes } from '../../../constants';
import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { statusCodes } from '../common';
import sessionActions from './actions';
import { configurations } from './configurations';

export function* authoriseAction(action) {
  if (action.meta && action.meta.response && action.meta.response.status === statusCodes.unauthorised) {
    yield put(sessionActions.session.clearSession());
    yield put(push({ pathname: routes.app.login }));
  }
}

function* sessionSagas() {
  yield all([
    takeEvery('*', authoriseAction)
  ].concat(
    mapSagasFromConfigurations('session')(configurations)
  ));
}

export default sessionSagas;



// WEBPACK FOOTER //
// ./src/state/modules/session/sagas.js